import { render, staticRenderFns } from "./CreateOrderModal.vue?vue&type=template&id=b0bb2452&"
import script from "./CreateOrderModal.vue?vue&type=script&lang=ts&"
export * from "./CreateOrderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports